const dashboard = {
  state: () => ({
    /** 儀表板設定對話框是否顯示 */
    dashboardSettingVisible: false,

    /** 看板資料長度 */
    kanbanDataLength: 0,
  }),

  mutations: {
    /** 是否顯示儀表板設定對話框 */
    setDashboardSettingVisible(state, value) {
      state.dashboardSettingVisible = value;
    },

    /** 看板資料長度 設值 */
    setkanbanDataLength(state, value) {
      state.kanbanDataLength = value;
    },
  },
};

export default dashboard;
